import { MessageCircle } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { waLink } from "@/lib/api";

export const WHATSAPP_MSG = "Hola Taller La Gringa, quisiera información sobre un servicio.";

export const FloatingWhatsApp = () => {
  const { site } = useSite() || {};
  return (
    <a href={waLink(site?.business?.whatsapp || "529991919300", WHATSAPP_MSG)} target="_blank" rel="noopener noreferrer"
      aria-label="Escríbenos por WhatsApp" data-testid="floating-whatsapp-btn"
      className="fixed bottom-5 right-5 z-50 grid h-14 w-14 place-items-center rounded-full bg-[#25D366] text-white shadow-2xl shadow-black/20 transition-transform hover:scale-110">
      <MessageCircle size={28} />
    </a>
  );
};

export const PLACE_ID = "ChIJL4NBWbl7Vo8RDaOJNklGYuU";
export const MAPS_URL = `https://www.google.com/maps/search/?api=1&query=Taller+de+Suspensiones+La+Gringa+M%C3%A9rida&query_place_id=${PLACE_ID}`;
export const DIRECTIONS_URL = `https://www.google.com/maps/dir/?api=1&destination=Taller+de+Suspensiones+La+Gringa+M%C3%A9rida&destination_place_id=${PLACE_ID}`;

export const MapEmbed = ({ height = 420 }) => (
  <div className="relative">
    <iframe title="Ubicación del Taller de Suspensiones La Gringa" data-testid="map-embed" loading="lazy" referrerPolicy="no-referrer-when-downgrade"
      className="w-full rounded-xl border border-line" style={{ height }}
      src="https://www.google.com/maps?q=Taller+de+Suspensiones+La+Gringa,+Calle+136+715-A,+M%C3%A9rida,+Yucat%C3%A1n&z=17&output=embed" />
    <a href={MAPS_URL} target="_blank" rel="noopener noreferrer" className="btn-gold absolute bottom-4 left-4 !py-2.5 shadow-lg" data-testid="map-open-btn">
      Abrir en Google Maps
    </a>
  </div>
);
